import axios from 'axios'
import { protocol } from '@/config'

export default {
  // 课程标准化-获取课程筛选条件
  getCourseSift: ({ location, provinceId, grade, courseType }, config = {}) =>
    axios.get(`courses/sift/1/${location}/${provinceId}/${grade}/${courseType}`, config),
  difficultGuide: ({ subject, grade }, config = {}) =>
    axios.get(
      `${protocol}//examination.xueersi.com/grading/${subject}/${grade}/`,
      config
    ), // 一分钟了解难度
  difficultGuideNextQues: ({ gradingId, nextquestionId }, config = {}) =>
    axios.get(
      `${protocol}//examination.xueersi.com/grading/nextQuestion/${gradingId}/${nextquestionId}/`,
      config
    ), // 获取下一题信息
  getDifficultDegree: (config = {}) =>
    axios.post(`${protocol}//examination.xueersi.com/grading/recommend/`, config),
  threeLessonWwwSift: ({ grade, subject }, config = {}) =>
    axios.get(`threeLessonWwwSift/${subject}/${grade}/`, config) // 三节课删选条件
}



// WEBPACK FOOTER //
// ./src/networks/api/CourseCenter/index.js